export const TypeMyOwn = ({
  setBoxFocus = () => {},
  setDisplayTypeMyOwnOptions = () => {},
}) => {
  return (
    <>
      {
        <div className="type-my-own-prompt--wrapper">
          <div className="type-my-own-btn-group">
            <button
              className="foundry--button button--outlined btn--round--border btn--sm type-my-own-btn"
              onClick={() => {
                setBoxFocus(0)
                setDisplayTypeMyOwnOptions('start-from-scratch')
              }}
            >
              <span className="button--label">Start from scratch</span>
            </button>
            <p>or</p>
            <button
              className="foundry--button button--outlined btn--round--border btn--sm type-my-own-btn"
              onClick={() => {
                setBoxFocus(false)
                setDisplayTypeMyOwnOptions('edit-common-list')
              }}
            >
              <span className="button--label">Edit a common list</span>
            </button>
          </div>
        </div>
      }
    </>
  )
}
